import { P00039DataRxTxIndex } from '../../P00039Sync';
import { IProduct } from '../../../IProduct';
import { getPoolMasterClass } from '../../../../ECoSystemsHelper';
import { Pool } from '../../../../../../apis/pool.api';

export function P0003601FunctionFinish(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  const master = getPoolMasterClass(pool);
  const presence = master?.hasProduct(pool, productClass) ?? 0;

  editValue(
    P00039DataRxTxIndex.FiltrationVS_Installation,
    'fvsIConfigurationProduit',
    presence != 0,
    null,
    productClass,
  );
}
